
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifi-swap",
      function () {
        return require("private-next-pages/lifi-swap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifi-swap"])
      });
    }
  